var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPipes(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.596 28H0c0 8.822 7.895 16 17.6 16 9.705 0 17.6-7.178 17.6-16h-2.597c0 7.52-6.73 13.64-15.003 13.64S2.596 35.52 2.596 28z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.32 16.044l-1.837-4.598c-1.021.26-2.695.163-3.284-.043l2.423 8.467c.68 1.614 1.777 2.45 2.44 3.034l7.775 6.551c.8.718 1.692.699 2.31.105.682-.658.3-1.378-.212-1.93l-5.94-6.058 4.464-3.436 5.589-2.636c.68-.375 1.048-1.092.93-1.816L32.031 9c-.97.103-1.875.207-2.744.316.316 1.085.666 2.313.796 2.836.129.515.26 1.142-.552 1.606-.977.56-3.496 1.983-3.496 1.983l2.198-1.993c.6-.476.83-1.243.58-1.937l-.834-2.325c-1.23.168-2.409.346-3.611.545l.596 1.659-2.253 1.783-4.392 2.571zM9.988 23.315c-.416 1.613.684 3.226 2.459 3.605 1.774.378 3.549-.623 3.966-2.236.416-1.614-.687-3.226-2.46-3.604-1.774-.379-3.549.623-3.965 2.235zM39.163.103C28.377 2.237 25.111 2.63 15.012 3.471c-2.766.23-4.244 2.029-3.982 3.803.305 2.074 2.571 3.074 4.959 2.617 9.083-1.737 12.643-2.457 24.152-3.367 2.766-.22 4.114-2.017 3.82-3.786-.395-2.36-2.844-3.022-4.798-2.635z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipes);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "45a07c213cc3a1dc39905e59b9119427.svg";
export { MemoForwardRef as ReactComponent };